import React, { useState } from 'react';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-navy-900 text-gray-400 py-8 text-center text-sm" data-id="element-179">
        <div className="max-w-4xl mx-auto px-4" data-id="element-180">
          <div className="flex justify-center gap-6 mb-4" data-id="element-181">
            <button onClick={() => setActiveModal('privacy')} className="hover:text-white transition-colors underline underline-offset-2" data-id="element-182">
              Política de Privacidad
            </button>
            <span className="text-gray-600" data-id="element-183">|</span>
            <button onClick={() => setActiveModal('terms')} className="hover:text-white transition-colors underline underline-offset-2" data-id="element-184">
              Términos y Condiciones
            </button>
          </div>
          <p className="mb-2" data-id="element-185">
            &copy; {new Date().getFullYear()} RUTA IT USA. Todos los derechos
            reservados.
          </p>
          <p className="text-xs opacity-70 max-w-2xl mx-auto" data-id="element-186">
            Este sitio no es parte del sitio web de Google, Facebook o Meta Inc.
            Además, este sitio NO está respaldado por Google o Facebook de
            ninguna manera. GOOGLE y FACEBOOK son marcas comerciales de sus
            respectivas empresas.
          </p>
        </div>
      </footer>

      {/* Modal */}
      {activeModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-187">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[85vh] overflow-hidden flex flex-col" onClick={e => e.stopPropagation()} data-id="element-188">
            {/* Modal Header */}
            <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 bg-gray-50" data-id="element-189">
              <h2 className="text-xl font-bold text-navy" data-id="element-190">
                {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
              </h2>
              <button onClick={() => setActiveModal(null)} className="p-2 rounded-full hover:bg-gray-200 transition-colors" aria-label="Cerrar" data-id="element-191">
                <X className="h-5 w-5 text-gray-500" data-id="element-192" />
              </button>
            </div>

            {/* Modal Body */}
            <div className="overflow-y-auto p-6 text-gray-700 text-sm leading-relaxed space-y-4" data-id="element-193">
              {activeModal === 'privacy' ? <PrivacyContent data-id="element-194" /> : <TermsContent data-id="element-195" />}
            </div>

            {/* Modal Footer */}
            <div className="px-6 py-4 border-t border-gray-200 bg-gray-50 text-center" data-id="element-196">
              <button onClick={() => setActiveModal(null)} className="bg-navy text-white font-bold px-6 py-2 rounded-lg hover:bg-navy-700 transition-colors text-sm" data-id="element-197">
                Cerrar
              </button>
            </div>
          </div>
        </div>}
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-xs text-gray-500" data-id="element-198">Última actualización: Marzo 2026</p>

      <h3 className="text-lg font-bold text-navy" data-id="element-199">
        1. Información que Recopilamos
      </h3>
      <p data-id="element-200">
        Al realizar una compra en nuestro sitio, recopilamos la información
        necesaria para procesar tu pedido, incluyendo tu nombre, dirección de
        correo electrónico y datos de pago. No almacenamos información de
        tarjetas de crédito directamente; todos los pagos son procesados de
        forma segura por nuestro proveedor de pagos.
      </p>

      <h3 className="text-lg font-bold text-navy" data-id="element-201">2. Uso de la Información</h3>
      <p data-id="element-202">Utilizamos tu información personal exclusivamente para:</p>
      <ul className="list-disc pl-6 space-y-1" data-id="element-203">
        <li data-id="element-204">Procesar y entregar tu compra digital.</li>
        <li data-id="element-205">Enviarte el enlace de descarga del producto.</li>
        <li data-id="element-206">Comunicarnos contigo sobre tu pedido o solicitudes de soporte.</li>
        <li data-id="element-207">Enviarte actualizaciones del producto si aplica.</li>
      </ul>

      <h3 className="text-lg font-bold text-navy" data-id="element-208">3. Protección de Datos</h3>
      <p data-id="element-209">
        Implementamos medidas de seguridad técnicas y organizativas para
        proteger tu información personal contra acceso no autorizado,
        alteración, divulgación o destrucción. Toda la comunicación se realiza a
        través de conexiones cifradas (SSL/TLS).
      </p>

      <h3 className="text-lg font-bold text-navy" data-id="element-210">4. Compartir Información</h3>
      <p data-id="element-211">
        No vendemos, intercambiamos ni transferimos tu información personal a
        terceros. La única excepción son los proveedores de servicios de
        confianza que nos ayudan a operar nuestro sitio web y procesar pagos,
        quienes están obligados a mantener la confidencialidad de dicha
        información.
      </p>

      <h3 className="text-lg font-bold text-navy" data-id="element-212">5. Cookies</h3>
      <p data-id="element-213">
        Nuestro sitio puede utilizar cookies para mejorar tu experiencia de
        navegación y analizar el tráfico del sitio. Puedes configurar tu
        navegador para rechazar cookies, aunque esto podría afectar algunas
        funcionalidades.
      </p>

      <h3 className="text-lg font-bold text-navy" data-id="element-214">6. Tus Derechos</h3>
      <p data-id="element-215">
        Tienes derecho a acceder, corregir o eliminar tu información personal en
        cualquier momento. También puedes solicitar que dejemos de enviarte
        comunicaciones de marketing.
      </p>

      <h3 className="text-lg font-bold text-navy" data-id="element-216">
        7. Cambios a esta Política
      </h3>
      <p data-id="element-217">
        Nos reservamos el derecho de actualizar esta política de privacidad en
        cualquier momento. Los cambios serán publicados en esta página con la
        fecha de actualización correspondiente.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-xs text-gray-500" data-id="element-218">Última actualización: Marzo 2026</p>

      <h3 className="text-lg font-bold text-navy" data-id="element-219">
        1. Aceptación de los Términos
      </h3>
      <p data-id="element-220">
        Al acceder a este sitio web y/o realizar una compra, aceptas cumplir con
        estos Términos y Condiciones. Si no estás de acuerdo con alguna parte de
        estos términos, no debes utilizar nuestro sitio ni adquirir nuestros
        productos.
      </p>

      <h3 className="text-lg font-bold text-navy" data-id="element-221">2. Producto Digital</h3>
      <p data-id="element-222">
        RUTA IT USA es un producto digital (guía en formato PDF y materiales
        complementarios) que se entrega mediante descarga electrónica inmediata
        después de la compra. Este producto es de carácter informativo y
        educativo.
      </p>

      <h3 className="text-lg font-bold text-navy" data-id="element-223">3. Resultados</h3>
      <p data-id="element-224">
        Los resultados mencionados en nuestra página de ventas son ejemplos
        basados en datos públicos del mercado laboral de EE.UU. y las
        certificaciones de Google. No garantizamos resultados específicos, ya
        que estos dependen del esfuerzo individual, nivel de inglés, situación
        migratoria, ubicación geográfica y otros factores personales de cada
        usuario.
      </p>

      <h3 className="text-lg font-bold text-navy" data-id="element-225">4. Política de Reembolso</h3>
      <p data-id="element-226">
        Ofrecemos una garantía de devolución de 30 días. Si dentro de los
        primeros 30 días desde la fecha de compra consideras que el producto no
        cumple con tus expectativas, puedes solicitar un reembolso completo sin
        necesidad de justificación. Para solicitar tu reembolso, simplemente
        envíanos un mensaje.
      </p>

      <h3 className="text-lg font-bold text-navy" data-id="element-227">5. Propiedad Intelectual</h3>
      <p data-id="element-228">
        Todo el contenido incluido en RUTA IT USA (textos, diseños, plantillas,
        checklists y guiones) es propiedad intelectual protegida. Al adquirir el
        producto, obtienes una licencia personal e intransferible para uso
        individual. Queda prohibida la reproducción, distribución o reventa del
        material sin autorización expresa.
      </p>

      <h3 className="text-lg font-bold text-navy" data-id="element-229">6. Marcas de Terceros</h3>
      <p data-id="element-230">
        Google, Coursera, y todas las empresas mencionadas en la guía son marcas
        registradas de sus respectivos propietarios. RUTA IT USA no está
        afiliado, patrocinado ni respaldado por Google, Coursera ni ninguna de
        las empresas mencionadas. La información sobre certificaciones y
        empleadores se basa en datos públicamente disponibles.
      </p>

      <h3 className="text-lg font-bold text-navy" data-id="element-231">
        7. Limitación de Responsabilidad
      </h3>
      <p data-id="element-232">
        RUTA IT USA proporciona información educativa y orientación general. No
        somos responsables de decisiones tomadas basándose en nuestro contenido.
        No ofrecemos asesoría legal, migratoria ni laboral. Recomendamos
        consultar con profesionales calificados para situaciones específicas.
      </p>

      <h3 className="text-lg font-bold text-navy" data-id="element-233">8. Modificaciones</h3>
      <p data-id="element-234">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Las modificaciones entrarán en vigor inmediatamente después de
        su publicación en el sitio web.
      </p>
    </>;
}